/* TapMeAwake PDP — interactivity + AJAX cart (vanilla, no deps) */
(function () {
  if (window.__tmapdpInit) return;
  window.__tmapdpInit = true;

  var MF = (window.Shopify && Shopify.money_format) || '${{amount}}';
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var out = String(MF)
      .replace(/\{\{\s*amount\s*\}\}/g, v)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, v.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
    return out || ('$' + v);
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  /* ref-counted scroll lock so overlapping overlays (menu + cart) don't unlock early */
  var _lockCount = 0;
  function lock() { _lockCount++; document.body.style.overflow = 'hidden'; }
  function unlock() { _lockCount = Math.max(0, _lockCount - 1); if (_lockCount === 0) document.body.style.overflow = ''; }

  /* ---------- Focus management for overlays (drawer + menu) ---------- */
  var FOCUSABLE = 'a[href],area[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var _lastFocus = null;
  var _trapEl = null;
  function _onTrapKey(e) {
    if (e.key !== 'Tab' || !_trapEl) return;
    var items = $all(FOCUSABLE, _trapEl).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  // mark everything except the overlay as inert/aria-hidden so AT + tab skip it
  function _setBackgroundInert(overlay, on) {
    var root = document.querySelector('.tmapdp');
    var siblings = root ? Array.prototype.slice.call(document.body.children) : [];
    siblings.forEach(function (node) {
      if (node === overlay || node.contains(overlay) || node.tagName === 'SCRIPT' || node.tagName === 'STYLE') return;
      if (on) { node.setAttribute('data-tmapdp-inert', ''); node.setAttribute('aria-hidden', 'true'); try { node.inert = true; } catch (_) {} }
      else if (node.hasAttribute('data-tmapdp-inert')) { node.removeAttribute('data-tmapdp-inert'); node.removeAttribute('aria-hidden'); try { node.inert = false; } catch (_) {} }
    });
  }
  function openOverlay(overlay, focusTarget) {
    _lastFocus = document.activeElement;
    _trapEl = overlay;
    overlay.removeAttribute('aria-hidden');
    _setBackgroundInert(overlay, true);
    document.addEventListener('keydown', _onTrapKey, true);
    // move focus inside (next frame so it's visible/focusable)
    requestAnimationFrame(function () { (focusTarget || $all(FOCUSABLE, overlay)[0] || overlay).focus(); });
  }
  function closeOverlay(overlay) {
    document.removeEventListener('keydown', _onTrapKey, true);
    _setBackgroundInert(overlay, false);
    overlay.setAttribute('aria-hidden', 'true');
    _trapEl = null;
    if (_lastFocus && _lastFocus.focus) _lastFocus.focus();
    _lastFocus = null;
  }

  /* ---------- Bundle / variant selector (Shopify variants = single source of truth) ---------- */
  function selectBundle(btn) {
    var group = btn.closest('[data-tmapdp-bundles]') || document;
    $all('[data-tmapdp-bundle]', group).forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('tmapdp-bundle-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var radio = $('[data-tmapdp-radio]', b);
      if (radio) radio.innerHTML = on ? '<span class="tmapdp-radio-dot"></span>' : '';
    });
    var variantId = btn.getAttribute('data-variant-id') || '';
    var price = btn.getAttribute('data-price') || '';
    var compare = btn.getAttribute('data-compare') || '';
    var save = btn.getAttribute('data-save') || '';
    var available = btn.getAttribute('data-available') !== 'false';
    var label = btn.getAttribute('data-variant-title') || '';
    if (label === 'Default Title') label = '';
    // point every product form at the selected variant (cart == displayed price)
    if (variantId) $all('[data-tmapdp-id-input]').forEach(function (e) { e.value = variantId; });
    // all price displays come from the variant's data-* (rendered by Liquid | money)
    $all('[data-tmapdp-price]').forEach(function (e) { e.textContent = price; });
    $all('[data-tmapdp-compare]').forEach(function (e) { e.textContent = compare; });
    $all('[data-tmapdp-save]').forEach(function (e) { e.textContent = save; e.style.display = save ? '' : 'none'; });
    $all('[data-tmapdp-atc-price]').forEach(function (e) { e.textContent = price; });
    $all('[data-tmapdp-sticky-label]').forEach(function (e) { if (label) e.textContent = label.trim(); });
    // reflect availability on the add-to-cart buttons
    $all('[data-tmapdp-atc-btn]').forEach(function (e) { e.disabled = !available; });
  }

  /* ---------- Accordions (hero mini-FAQ, main FAQ, benefit rows) ---------- */
  function toggleAcc(btn) {
    var row = btn.closest('[data-tmapdp-acc-row]');
    if (!row) return;
    var open = row.classList.toggle('tmapdp-acc-open');
    var icon = $('[data-tmapdp-acc-icon]', btn);
    if (icon) icon.textContent = open ? '−' : '+';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* ---------- Cart drawer (AJAX) ---------- */
  function emptyMarkup() {
    return '<div class="tmapdp-cart-empty">' +
      '<div class="tmapdp-cart-empty-ic">○</div>' +
      '<div class="tmapdp-cart-empty-t">Your cart is empty</div>' +
      '<div class="tmapdp-cart-empty-s">Add the TapMeAwake Pulse to start your calmer mornings.</div>' +
      '</div>';
  }
  function renderCart(cart) {
    $all('[data-tmapdp-cart-count]').forEach(function (e) {
      e.textContent = cart.item_count;
      e.style.display = cart.item_count > 0 ? '' : 'none';
    });
    var body = $('#tmapdp-cart-items');
    var foot = $('#tmapdp-cart-foot');
    if (!body) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = emptyMarkup();
      if (foot) foot.style.display = 'none';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      return '<div class="tmapdp-ci">' +
        (img ? '<img class="tmapdp-ci-img" src="' + img + '" alt="">' : '<div class="tmapdp-ci-img"></div>') +
        '<div class="tmapdp-ci-info">' +
        '<div class="tmapdp-ci-title">' + it.product_title + '</div>' +
        (variant ? '<div class="tmapdp-ci-variant">' + variant + '</div>' : '') +
        '<div class="tmapdp-ci-qtyrow">' +
        '<div class="tmapdp-qty">' +
        '<button class="tmapdp-qty-btn" data-tmapdp-qty="' + it.key + '" data-delta="-1" aria-label="Decrease">−</button>' +
        '<span class="tmapdp-qty-n">' + it.quantity + '</span>' +
        '<button class="tmapdp-qty-btn" data-tmapdp-qty="' + it.key + '" data-delta="1" aria-label="Increase">+</button>' +
        '</div>' +
        '<a class="tmapdp-ci-remove" data-tmapdp-remove="' + it.key + '">Remove</a>' +
        '</div></div>' +
        '<div class="tmapdp-ci-price">' + money(it.final_line_price) + '</div>' +
        '</div>';
    }).join('');
    var sub = $('#tmapdp-subtotal');
    if (sub) sub.textContent = money(cart.total_price);
    if (foot) foot.style.display = 'block';
  }
  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  function openCart() {
    var d = $('#tmapdp-drawer'), b = $('#tmapdp-backdrop');
    if (!d) return;
    var wasOpen = d.classList.contains('tmapdp-open');
    d.classList.add('tmapdp-open');
    if (b) b.classList.add('tmapdp-open');
    if (!wasOpen) { lock(); openOverlay(d, $('[data-tmapdp-cart-close]', d)); }
    loadCart();
  }
  function closeCart() {
    var d = $('#tmapdp-drawer'), b = $('#tmapdp-backdrop');
    if (!d || !d.classList.contains('tmapdp-open')) return;
    d.classList.remove('tmapdp-open');
    if (b) b.classList.remove('tmapdp-open');
    unlock();
    closeOverlay(d);
  }
  function addToCart(variantId, qty) {
    if (!variantId) { openCart(); return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () { openCart(); })
      .catch(function () { openCart(); });
  }
  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  /* ---------- Mobile menu ---------- */
  function openMenu() {
    var m = $('#tmapdp-menu');
    if (!m || m.classList.contains('tmapdp-open')) return;
    m.classList.add('tmapdp-open'); lock(); openOverlay(m, $('[data-tmapdp-menu-close]', m));
  }
  function closeMenu() {
    var m = $('#tmapdp-menu');
    if (!m || !m.classList.contains('tmapdp-open')) return;
    m.classList.remove('tmapdp-open'); unlock(); closeOverlay(m);
  }

  /* ---------- Delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-tmapdp-bundle]'))) { e.preventDefault(); selectBundle(el); return; }
    if ((el = t.closest('[data-tmapdp-acc]'))) { e.preventDefault(); toggleAcc(el); return; }
    if ((el = t.closest('[data-tmapdp-cart-open]'))) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-tmapdp-cart-close]') || t.id === 'tmapdp-backdrop') { e.preventDefault(); closeCart(); return; }
    if ((el = t.closest('[data-tmapdp-qty]'))) {
      e.preventDefault();
      var cur = parseInt(el.parentNode.querySelector('.tmapdp-qty-n').textContent, 10) || 0;
      changeQty(el.getAttribute('data-tmapdp-qty'), cur + parseInt(el.getAttribute('data-delta'), 10));
      return;
    }
    if ((el = t.closest('[data-tmapdp-remove]'))) { e.preventDefault(); changeQty(el.getAttribute('data-tmapdp-remove'), 0); return; }
    if (t.closest('[data-tmapdp-menu-open]')) { e.preventDefault(); openMenu(); return; }
    if (t.closest('[data-tmapdp-menu-close]')) { e.preventDefault(); closeMenu(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeMenu(); } });

  /* ---------- Add to cart via real product form (canonical Shopify) ---------- */
  // Intercept the product form submit: posts FormData (which always contains the
  // hidden name="id" = current variant.id) to /cart/add.js, then opens the drawer.
  // If JS is unavailable, the form posts natively to /cart/add — never silently fails.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-tmapdp-form]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    // Guard: ensure an id is present (variant, not product) before posting.
    if (!fd.get('id')) { openCart(); return; }
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          // surface Shopify's reason (e.g. sold out / invalid id) instead of failing silently
          var msg = (res.data && (res.data.description || res.data.message)) || 'Could not add to cart.';
          var err = form.querySelector('[data-tmapdp-form-error]');
          if (err) { err.textContent = msg; err.style.display = 'block'; }
          else { console.warn('[tmapdp] add to cart rejected:', msg); }
          return;
        }
        var err2 = form.querySelector('[data-tmapdp-form-error]');
        if (err2) err2.style.display = 'none';
        openCart();
      })
      .catch(function () { openCart(); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* ---------- Sticky buy bar (sentinel) + scroll-spy ---------- */
  function initObservers() {
    var sentinel = $('#tmapdp-sentinel'), sticky = $('#tmapdp-sticky');
    if (sentinel && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('tmapdp-sticky-show', past);
      }, { threshold: 0 }).observe(sentinel);
    }
    var spy = $all('[data-tmapdp-spy]');
    if (spy.length && 'IntersectionObserver' in window) {
      var ids = spy.map(function (a) { return (a.getAttribute('href') || '').slice(1); });
      var vis = {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { vis[en.target.id] = en.isIntersecting; });
        var active = ids.find(function (id) { return vis[id]; });
        if (active) spy.forEach(function (a) {
          a.classList.toggle('tmapdp-spy-active', (a.getAttribute('href') || '').slice(1) === active);
        });
      }, { rootMargin: '-120px 0px -60% 0px', threshold: 0 });
      ids.forEach(function (id) { var el = document.getElementById(id); if (el) io.observe(el); });
    }
  }

  /* ---------- Subtle scroll reveal (premium feel, progressive enhancement) ---------- */
  function initReveal() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    // reveal the inner block of each content section, plus product/review/feature cards
    var targets = $all('.tmapdp section > div, .tmapdp .col-grid > a');
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('tmapdp-in'); obs.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(function (el) {
      // never hide what's already in view on load (prevents above-the-fold flash)
      if (el.getBoundingClientRect().top < vh * 0.92) return;
      el.classList.add('tmapdp-reveal');
      io.observe(el);
    });
  }

  function init() {
    initObservers();
    initReveal();
    // initialise selected bundle from the pre-marked button
    var pre = $('[data-tmapdp-bundle].tmapdp-bundle-on') || $('[data-tmapdp-bundle]');
    if (pre) selectBundle(pre);
    loadCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-bind observers + bundle state when a section reloads
  // (delegated click/submit on document already survive; this re-inits the per-element observers).
  document.addEventListener('shopify:section:load', function () {
    initObservers();
    initReveal();
    var pre = $('[data-tmapdp-bundle].tmapdp-bundle-on') || $('[data-tmapdp-bundle]');
    if (pre) selectBundle(pre);
  });

  // expose for other scripts
  window.tmapdp = { openCart: openCart, closeCart: closeCart, refresh: loadCart };
})();
